module.exports = __webpack_public_path__ + "static/media/bj15ylogo.d302f621.png";